import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PartnerType } from '../models/partner.model';

export interface MetricsParams {
  total: number;
  created_last_week: number;
  percent_lastweek: number;
  active_total: number;
  active_created_last_week: number;
  percent_actived: number;
  commissions_total: number;
  percent_commissions_lastweek: number;
  by_state: {
    won: number;
    lost: number;
    in_progress: number;
  };
  amounts: {
    won: number;
    lost: number;
    in_progress: number;
  };
  by_type: Record<PartnerType, number>;
  amount_by_type: Record<PartnerType, number>;
  conversion_rate: number;
  top_partners: {
    id: number;
    name: string;
    opportunity_count: number;
    pipeline_amount: number;
    won_amount: number;
  }[];
  top_partners_by_sales: {
    id: number;
    name: string;
    value: number;
  }[];
  top_partners_by_opportunities: {
    id: number;
    name: string;
    count: number;
    value: number;
  }[];
  channel_activation: {
    total: number;
    with_deals: number;
    with_three_plus: number;
    inactive: number;
  };
  temporal: {
    labels: string[];
    created: number[];
    closed: number[];
  };
  // Deprecated fields kept for backward compatibility
  monthly: {
    month: string;
    count: number;
  }[];
  commissions_by_month: {
    month: string;
    total_commission: number;
  }[];
}

export interface MetricsResponse {
  data: MetricsParams;
  success: boolean;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class MetricsService {
  private readonly http = inject(HttpClient);

  getMetrics(params?: {
    range?: string | null;
    state?: string;
    start_date?: string | null;
    end_date?: string | null;
  }): Observable<MetricsResponse> {
    let url = `${environment.apiUrl}/hubspot/status/metrics`;
    if (params) {
      const httpParams: Record<string, string> = {};
      if (params.range) httpParams['range'] = params.range;
      if (params.state) httpParams['state'] = params.state;
      if (params.start_date) httpParams['start_date'] = params.start_date;
      if (params.end_date) httpParams['end_date'] = params.end_date;

      const query = Object.entries(httpParams)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');

      if (query) url = `${url}?${query}`;
    }

    return this.http.get<MetricsResponse>(url);
  }
}
